












import { defineComponent, ref, watch } from '@vue/composition-api';
import request from '@utils/request';
import { Message } from 'element-ui';
import { encrypt } from '@/utils/aes';

export default defineComponent({
  name: 'VerifyCode',
  props: {
    cellPhone: {
      type: Number || null,
      default: null,
    },
    type: {
      type: String,
      default: 'login',
    },
    workEmail: {
      type: String,
      default: '',
      required: true,
    },
  },
  setup(prop: any) {
    const time = ref(59);
    const isDisable = ref(false);

    watch(
      () => prop.workEmail,
      (newVal: number | null) => {
        if (newVal === 0 || newVal === null) {
          isDisable.value = true;
        } else {
          isDisable.value = false;
        }
      }, {
        immediate: true,
      }
    );

    const sendCheckCode = async () => {
      let params = {};
      if (prop.cellPhone) {
        params = {
          cellPhone: encrypt(String(prop.cellPhone)),
          type: prop.type,
          workEmail: encrypt(String(prop.workEmail)),
        };
      } else {
        params = {
          type: prop.type,
          workEmail: encrypt(String(prop.workEmail)),
        };
      }
      const res = await request('login', 'sendCheckCode', params);
      if (res.code === 2000) {
        Message.success('验证码已通过短信发送至你绑定的手机号');
        countdown();
      }
    };

    const countdown = () => {
      if (isDisable.value) return;

      isDisable.value = true;
      const timer = setInterval(() => {
        // eslint-disable-next-line no-plusplus
        time.value--;
        if (time.value === 0) {
          clearInterval(timer);
          isDisable.value = false;
          time.value = 59;
        }
      }, 1000);
    };

    return {
      time,
      isDisable,
      sendCheckCode,
    };
  },
});
